import { Injectable } from "@angular/core";
import { Subject, Observable } from "rxjs";

@Injectable()
export class RefreshCheckService {
  private shouldRefreshTravelData = new Subject<boolean>();

  refreshTravelData$: Observable<any> = this.shouldRefreshTravelData.asObservable();

  refreshTravelData(shouldRefreshData: boolean) {
    this.shouldRefreshTravelData.next(shouldRefreshData);
  }
}
